/**
 *  UserList.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// Tables
import {
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  Toolbar,
  TableHeaderRow,
  PagingPanel,
  SearchPanel,
} from "@devexpress/dx-react-grid-bootstrap3";

// notifications
import NotificationSystem from "react-notification-system";

// components
import AlertsModal from "./AlertsModal.jsx";
import Loading from "../Loader/Loader.jsx";

// style
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");

class AlertsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          name: "userName",
          title: "Nome",
          getCellValue: (row) => (row.user ? row.user.name : ""),
        },
        {
          name: "userPhone",
          title: "Telefone",
          getCellValue: (row) => (row.user ? row.user.phone : ""),
        },
        {
          name: "type",
          title: "Tipo",
          getCellValue: (row) =>
            row.type === 2 ? (
              <span className="badge-warning">CERCA VIRTUAL</span>
            ) : (
              <span className="badge-danger">ÁREA SINISTRO</span>
            ),
        },
        {
          name: "actions",
          title: "Ações",
          getCellValue: (row) => this.actions(row),
        },
      ],
      showModal: false,
      rowSelected: null,
      _notificationSystem: null,
      indexSelected: null,
      lat: 0,
      lon: 0,
      url: "",
      loading: false,
      searchValue: "",
      sortColumns: [],
      tableColumnExtensions: [],
    };

    this.changeSearchValue = (value) => this.setState({ searchValue: value });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  handleClose = () => {
    this.setState({ showModal: false, selection: [] });
  };

  handleShow = (row) => {
    this.setState({ loading: true }, () => {
      this.getLocation(row);
    });
  };

  actions = (row) => {
    const { users } = this.props;

    return (
      <div>
        <a
          onClick={() => {
            this.handleShow(row);
          }}
          className="link-edit"
        >
          <span>
            <i
              className={`glyphicon glyphicon-globe`}
              style={{ fontWeight: "bold" }}
            />{" "}
            MOSTRAR
          </span>
        </a>
      </div>
    );
  };

  getLocation = (row) => {
    const userLocationRef = firebase.database.ref(
      `/locationUsers/${row.key}/l`
    );

    userLocationRef.once("value").then((snapshot) => {
      const userLocation = snapshot.val();

      if (userLocation != null) {
        const userLat = userLocation[0];
        const userLong = userLocation[1];
        this.setState({
          rowSelected: row,
          loading: false,
          showModal: true,
          lat: userLat,
          long: userLong,
          url:
            "https://www.google.com/maps/embed/v1/search?q=" +
            userLat +
            "%2C%20" +
            userLong +
            "&key=AIzaSyBQY9mebdLSt8IRHgre47-X9sW6unp5NnE",
        });
      } else {
        this.setState({ loading: false }, () => {
          this.notify("Nenhuma localização encontrada.", "error");
        });
      }
    });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const {
      columns,
      searchValue,
      sortColumns,
      tableColumnExtensions,
      showModal,
      url,
      loading,
      rowSelected,
    } = this.state;
    const { list } = this.props;

    return (
      <div>
        {showModal && (
          <AlertsModal
            show={showModal}
            handleHide={this.handleClose}
            url={url}
            rowSelected={rowSelected}
          />
        )}

        {loading && <Loading />}

        <NotificationSystem ref="notificationSystem" style={style} />

        <Grid rows={list} columns={columns}>
          <SearchState
            value={searchValue}
            onValueChange={this.changeSearchValue}
          />

          <PagingState defaultCurrentPage={0} defaultPageSize={20} />

          <SortingState defaultSorting={sortColumns} />

          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />

          <Table columnExtensions={tableColumnExtensions} />
          <TableHeaderRow showSortingControls />
          <Toolbar />

          <SearchPanel />

          <PagingPanel pageSizes={[5, 15, 20, 25, 50, 100, 0]} />
        </Grid>
      </div>
    );
  }
}

export default AlertsList;



// WEBPACK FOOTER //
// ./src/views/Alerts/AlertsList.jsx